import React from 'react';
import Helmet from 'react-helmet';
import HtmlParser from 'html-react-parser';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import ResponsiveSlider from '../../components/ResponsiveSlider';
import PodcastCard from '../../components/cards/PodcastCard';
import { PATHS } from '../../utils/urls';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout  bodyClass="press" ontouchstart>
            <SEO title="Press | ChartHop | People Analytics, Visualized" />
            <Helmet>
                <meta
                    name="description"
                    content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Press | ChartHop | People Analytics, Visualized" />
                <meta property="og:description" content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more." />
                <meta property="og:image" content={`https://www.charthop.com/home/press-meta.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Press | ChartHop | People Analytics, Visualized" />
                <meta name="twitter:description" content="Read the latest news about ChartHop. Keep up to date with new company announcements, product releases and more." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/press-meta.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HERO CONTENT */}
            <section className="hero-centerSectionSpacing">
                <section className="d-flex flex-column contentBlock">
                    <div>
                        <h1 className="text-center">Press</h1>
                        <p className="text-center header-p mb-0">We're building the best people software on the planet.</p>
                        <p className="text-center header-p mb-0">And that's news.</p>
                    </div>
                </section>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing pb-0 flex-centeredColumn">
                <div className="contentBlock d-flex justify-content-between flex-wrap gridContainer">
                    {/* TECHCRUNCH */}
                    <div className="fullWidthCard">
                        <div className="logoContent">
                            <div>
                                <img src={'/press/techcrunch-logo.svg'} alt="Techcrunch" className="logo-techcrunch" />
                            </div>
                        </div>
                        <div className="testimonialContent">
                            <p>“The ChartHop platform is built like all strong structures these days in the world of tech: <br/><br/> Tons of integrations to feed data into ChartHop to make it richer; tons of integrations to export and use that data in more dedicated applications when needed; and an easy way for everyone to update data -- with easy and strong protections to keep confidential data as it should be.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/press/ingrid-lunden.png'} alt="Ingrid Lunden" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Ingrid Lunden</b></p>
                                    <p className="mb-0">Read more on <a href="https://techcrunch.com/2021/06/09/charthop-raises-35m-for-its-internal-org-chart-and-people-analytics-platform/" className="ctaStandard textInline" rel="noopener noreferrer" target="_blank">Techcrunch</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* FORTUNE */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <a href="https://fortune.com/2021/06/11/in-didi-ipo-a-one-time-rival-uber-stands-to-gain/">
                                    <img src={'/press/fortune-logo.svg'} alt="Fortune" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* BUSINESS INSIDER */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“When Andreessen Horowitz cofounder and general partner Ben Horowitz first saw ChartHop's product, founder Ian White remembers him saying, 'Every single person who's ever run a company is going to want this product.'<br/><br/>Now the powerhouse firm is 'tripling down,' by leading the company's $35 million Series B.”</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/Margaux-MacColl.jpeg'} alt="Margaux MacColl" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Margaux MacColl</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.businessinsider.com/andreessen-horowitz-bets-big-on-charthop-hr-startup-series-b-2021-6" className="ctaStandard textInline" rel="noopener noreferrer" target="_blank">Business Insider</a></p>
                                </div>
                            </div>
                            <div>
                                <img src={'/press/BI_light_background_color_vertical.png'} alt="business-insider" />
                            </div>
                        </div>
                    </div>
                    {/* FORBES */}
                    <div className="fullWidthCard">
                        <div className="logoContent">
                            <div>
                                <img src={'/press/forbes-01.svg'} alt="Forbes" className="logo-forbes" />
                            </div>
                        </div>
                        <div className="testimonialContent">
                            <p>“A lot of software is built to solve a particular operational task like collecting performance reviews, doing a background check, but there’s never really been  software that pulls it all together. ChartHop does.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/press/Igor-Bosilkovski.png'} alt="Igor Bosilkovski" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Igor Bosilkovski</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.google.com/url?q=https://www.forbes.com/sites/igorbosilkovski/2020/08/26/organizational-platform-charthop-raises-14-million-in-series-a-round-led-by-andreessen-horowitz/?sh%3D7432c0937788&sa=D&source=docs&ust=1634136427091000&usg=AOvVaw2hKjkwcil60Zsb6CWKXOEG" className="ctaStandard textInline" rel="noopener noreferrer" target="_blank">Forbes</a></p>
                                </div>                                        
                            </div>

                        </div>
                    </div>
                    {/* WSJ */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <a href="https://www.wsj.com/articles/tech-startups-ditch-the-office-for-far-flung-bonding-trips-11623854510" target="_blank">
                                    <img src={'/press/wsj-logo.svg'} alt="Wsj" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* JOSH BERSIN */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">"Look at ChartHop... a groundbreaking organizational analytics system that makes any type of analytics amazingly easy.”</p>
                        </div>

                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/josh-bersin.jpeg'} alt="Josh Bersin" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Josh Bersin</b></p>
                                    <p className="mb-0">Read more on <a href="https://joshbersin.com/2020/10/innovative-new-hr-tech-vendors-emerge-cultureamp-valamis-lattice-hitch-eskalera-and-more/" className="ctaStandard textInline">Josh Bersin</a></p>
                                </div>
                            </div>

                            <div>
                                <img src={'/press/josh-bersin.svg'} alt="Protocol" />
                            </div>
                        </div>
                    </div>
                    {/* FAST COMPANY */}
                    <div className="fullWidthCard-imbalanced">
                        <div className="testimonialContent">
                            <p>"Data has the power to spark action and help companies make informed and inclusive decisions. It can also enable HR and People leaders to identify inequalities and to align employees at all levels toward plans to address them.<br/><br/> Armed with data and a willingness to spur real change, we can achieve equal pay for all."</p>
                            <div className="quoteAuthorTag">
                                <img src={'/img/blog_author-2x.jpg'} alt="Ian White" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Ian White</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.fastcompany.com/90583315/well-never-solve-the-wage-gap-without-better-transparent-data" className="ctaStandard textInline" target="_blank">Fast company</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="logoContent sectionSpacing">
                            <div>
                                <img src={'/press/fast-company.svg'} alt="Fast company" className="andreessen" />
                            </div>
                        </div>
                    </div>
                    {/* CNBC */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <a href="https://www.cnbc.com/2020/07/13/tech-companies-curb-real-estate-expenses-end-leases-merge-offices.html" target="_blank">
                                    <img src={'/press/cnbc.svg'} alt="Cnbc" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* PROTOCOL */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">"ChartHop is building a better internal tool for companies to use to easily visualize their company's org structure and plan their future growth...Beyond making a fancier org chart, it helps companies analyze things like gender and pay equity and also model future open positions.”</p>
                        </div>

                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/biz-carson.png'} alt="Biz Carson" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Biz Carson</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.protocol.com/org-chart-startup-linkedin" target="_blank" className="ctaStandard textInline">Protocol</a></p>
                                </div>
                            </div>

                            <div>
                                <img src={'/press/protocol-logo.svg'} alt="Protocol" />
                            </div>
                        </div>
                    </div>
                    {/* A16Z */}

                    <div className="fullWidthCard-imbalanced">
                        <div className="testimonialContent">
                            <p>“ChartHop is the kind of HR software a deeply technical engineering leader would build if they were sick of dealing with spreadsheets to manage hundreds of engineers.”</p>
                            <div className="quoteAuthorTag">
                                <img src={'/supporters/david-ulevitch.png'} alt="David Ulevitch" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>David Ulevitch</b></p>
                                    <p className="mb-0">Read more on <a href="https://a16z.com/2020/02/20/investing-in-charthop/" target="_blank" className="ctaStandard textInline"> a16z blog</a></p>
                                </div>
                            </div>
                        </div>
                        <div className="logoContent sectionSpacing">
                            <div>
                                <img src={'/press/andreessen-horowitz.svg'} alt="a16z" className="andreessen" />
                            </div>
                        </div>
                    </div>
                    {/* BUITLIN */}
                    <div className="oneThirdCard">
                        <div>
                            <div>
                                <a href="https://www.builtinnyc.com/2021/06/09/charthop-raises-35m-series-b-hiring?utm_source=linkedin&utm_medium=organic_social&utm_content=47bf5636-5b77-45d8-98c0-1490d2e97e22&utm_campaign=breaking_news" target="_blank">
                                    <img src={'/press/builtinnyc.svg'} alt="Buitlin" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* SHRM */}
                    <div className="twoThirdCard">
                        <div>
                            <p className="cardQuote">“Since implementing the system a year ago, Even Financial has centralized data by integrating ChartHop with the company's HRIS, performance management system, equity management system and applicant tracking system.
                                <br/><br/>They now have a system in place that enables Even's leadership and hiring managers to propose workforce scenarios based on the goals they are specifically looking to achieve quarter over quarter and year over year."</p>
                        </div>
                        <div>
                            <div className="quoteAuthorTag">
                                <img src={'/press/lewis_nicole.jpg'} alt="Nicole Lewis" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Nicole Lewis</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.shrm.org/resourcesandtools/hr-topics/technology/pages/data-management-tools-can-improve-employee-experience.aspx" target="_blank" className="ctaStandard textInline">SHRM</a></p>
                                </div>
                            </div>
                            <div>
                                <img src={'/press/shrm.svg'} alt="SHRM" />
                            </div>
                        </div>
                    </div>
                    {/* PROTOCOL */}
                    <div className="fullWidthCard">
                        <div className="logoContent">
                            <div>
                                <img src={'/press/protocol-logo.svg'} alt="Protocol" className="logo-techcrunch" />
                            </div>
                        </div>
                        <div className="testimonialContent">
                            <p>"ChartHop allows executives to 'slice and dice' their employee data and compare performance ratings against compensation and promotion data, which allows for more agility and continuous planning, according to founder and CEO/CTO Ian White. If a person has three outstanding performance ratings in a row but hasn't received a raise in that same period, maybe they deserve a bigger equity refresh, he explained."</p>
                            <div className="quoteAuthorTag">
                                <img src={'/press/michele-ma.webp'} alt="Michelle Ma" />
                                <div className="d-flex flex-column">
                                    <p className="my-0"><b>Michelle Ma</b></p>
                                    <p className="mb-0">Read more on <a href="https://www.protocol.com/workplace/performance-reviews-tech-companies" className="ctaStandard textInline" rel="noopener noreferrer" target="_blank">Protocol</a></p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            {/* PODCAST */}
            <section className="sectionSpacing pb-0 flex-centeredColumn podcast">
                <h2 className="text-center centerSpacing">Podcast & Videos</h2>

                <div className="contentBlock justify-content-between flex-wrap gridContainer">
                    <ResponsiveSlider
                        elements={[
                            <PodcastCard
                                urlImg="/press/digitalHR.png"
                                title="Digital HR Leaders"
                                description={<p>“To make data actionable, it needs to be accurate, accessible and applicable.<br /><br /> Automatically collecting and organising the data, removes a lot of the manual work and human error. You want to have this real source of truth for the people who need it.“</p>}
                                link="https://www.myhrfuture.com/digital-hr-leaders-podcast/2021/4/27/how-to-manage-and-visualise-people-data-to-create-actionable-insights"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/david-green.jpg"
                                authorName="David Green"
                                authorVideoTitle="Digital HR Leaders"
                            />,
                            <PodcastCard
                                urlImg="/press/a16z.png"
                                title="We Don't All Need to Learn to Code"
                                description={<p>“You’re all familiar with the pains of the annual planning process and the dreaded spreadsheets that don't have answers to the questions you really have.<br/><br/> 
                                ChartHop can answer the questions that organizations that are trying to be more thoughtful and intentional in their planning and their growth are asking.“</p>}
                                link="https://www.youtube.com/watch?v=GAnanqIb9CE"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/david-ulevitch.png"
                                authorName="David Ulevitch"
                                authorVideoTitle="a16z"
                                isVideo={true}
                            />,
                            <PodcastCard
                                urlImg="/press/kruze-consulting.png"
                                title="Kruze Consulting"
                                description={<p>“ChartHop brings clarity to the organizational structure.<br /><br />You wouldn’t try to run a sales team without using Salesforce or another CRM, but we’ve all been running our companies for many, many years without that source of truth and place to go for our organizational structure and people.”</p>}
                                link="https://podcasts.apple.com/us/podcast/ian-white-charthop-on-bringing-transparency-to-your/id1125300270?i=1000494842581"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/scot-orn.jpg"
                                authorName="Scott Orn"
                                authorVideoTitle="Kruze Consulting"
                            />,
                            <PodcastCard
                                urlImg="/press/workFuture.png"
                                title="Work and the Future with Linda Nazareth"
                                description={<p>“A big part of any startup is the ability to build a winning culture of a small group of people who can achieve a lot of great things together.<br /><br /> And if you want to align people and keep them motivated, you should pay them appropriately for their work, not by where they live.”</p>}
                                link="https://podcasts.apple.com/ca/podcast/a-podcast-about-work-the-future-and-how-they-will-go-together/id1515835849#episodeGuid=https%3A%2F%2Frelentlesseconomics.com%2F%3Fp%3D3529"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/Linda-Nazareth.jpg"
                                authorName="Linda Nazareth"
                                authorVideoTitle="Work and the Future"
                            />,
                            /*<PodcastCard
                                urlImg="/press/between-term-sheets.png"
                                title="Between the Term Sheets"
                                description={<p>“People are your most important asset at an organization, hands down. People leaders have historically not had tools they needed to be the true strategic partners that they are.<br /><br /> That’s what ChartHop is changing.“</p>}
                                link="https://podcasts.apple.com/us/podcast/episode-24-charthop/id1507779944?i=1000494457116"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/liz-melton.jpg"
                                authorName="Liz Melton"
                                authorVideoTitle="Between the Term Sheets"
                            />,*/
                            <PodcastCard
                                urlImg="/press/forward-thinking-founders.jpg"
                                title="Forward Thinking Founders"
                                description={<p>“We’re pioneering a new category that empowers leaders to truly understand their organizations past and current state, and gives them the context they need to plan for their future.<br/><br/> HR leaders are demanding tools that give them the insights and analytics to be strategic + solve a lot of the manual workflows they still have to.“</p>}
                                link="https://podcasts.apple.com/us/podcast/forward-thinking-founders/id1454168902"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/mat-sherman.png"
                                authorName="Mat Sherman"
                                authorVideoTitle="Forward Thinking Founders"
                            />,
                            <PodcastCard
                                urlImg="/press/tech-talks-daily.png"
                                title="ChartHop, The Tech Helping Businesses Run and Scale Better"
                                description={<p>“Getting in the habit of doing planning continuously as business changes is a huge competitive advantage.<br/><br/>ChartHop takes the overhead out of the planning and the approval processes that exist today and helps organizations be more nimble and intentional in their growth.”</p>}
                                link="http://techblogwriter.libsyn.com/chart-hop"
                                cardColor="linear-gradient(0deg,#eff4fa,#f8fafd)"
                                authorImage="/press/neil-hughes.png"
                                authorName="Neil C. Hughes"
                                authorVideoTitle="The Tech Talks Daily"
                            />

                        ]}
                    />
                </div>
                <div className="sectionSpacing"> </div>
            </section>

            {/* HERO CONTENT */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing text-center">
                <div className="flex-centeredColumn">
                    <p className="text-center mb-0"> For media inquiries contact <a href="mailto:marketing@charthop.com" rel="noopener noreferrer" target="_blank">marketing@charthop.com</a>.</p>
                </div>

            </section>

            {/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"company-press-demo-bottom"} headertext={HtmlParser("<h2>See what everyone is talking about. </h2><h2> Get in touch!</h2>")} />
            </section>
        </Layout>
    );
};


export default Home;
